<template>
  <!-- 项目施工 -->
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="12">
          <a-col :md="6" :sm="12">
            <a-form-item label="项目编号">
              <a-input v-model="query.establishmentNo" placeholder="请输入项目编号" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="项目名称">
              <a-input v-model="query.establishmentName" placeholder="请输入项目名称" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="计划开始时间">
              <a-date-picker
                style="width: 100%"
                format="YYYY-MM-DD HH:mm:ss"
                valueFormat="YYYY-MM-DD HH:mm:ss"
                show-time
                placeholder="请选择计划开始时间"
                v-model="query.startTime"
                allow-clear
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="计划结束时间">
              <a-date-picker
                format="YYYY-MM-DD HH:mm:ss"
                valueFormat="YYYY-MM-DD HH:mm:ss"
                style="width: 100%"
                show-time
                placeholder="请选择计划结束时间"
                v-model="query.endTime"
                allow-clear
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="施工状态">
              <a-select v-model="query.constructionStatus" allow-clear placeholder="请选择施工状态">
                <a-select-option :value="0"> 未开始 </a-select-option>
                <a-select-option :value="1"> 施工进行中 </a-select-option>
                <a-select-option :value="2"> 施工已完成 </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="12" :sm="24" style="display: flex">
            <a-form-item>
              <a-button type="primary" @click="queryList">查询</a-button>
              <a-button style="margin-left: 12px" @click="resetList">重置</a-button>
              <a-button type="primary" style="margin-left: 12px" @click="chakan()" v-action:project>结项</a-button>
              <a-button type="danger" style="margin-left: 12px" @click="deleteSelectRow()" v-action:delete
                >删除</a-button
              >
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <a-table
      ref="table"
      rowKey="id"
      size="middle"
      bordered
      :disabled="false"
      :columns="columns"
      :scroll="{ x: 2100 }"
      :loading="dataListLoading"
      :dataSource="list"
      :pagination="pagination"
      :rowSelection="{ selectedRowKeys: this.selectedRows, onChange: onSelectChange }"
      :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
      @change="pageChange"
    >
      <span slot="constructionStatus" slot-scope="text, record">
        <a-tag v-if="record.constructionStatus === 0" color="rgb(255, 99, 71)">未开始</a-tag>
        <a-tag v-if="record.constructionStatus === 1" color="#f98303">施工进行中</a-tag>
        <a-tag v-if="record.constructionStatus === 2" color="rgb(50, 205, 50)">施工已完成</a-tag>
      </span>
      <span slot="approveStatus" slot-scope="text, record">
        <a-tag v-if="record.approveStatus === 0" color="rgb(255, 99, 71)">待审批</a-tag>
        <a-tag v-if="record.approveStatus === 1" color="rgb(50, 205, 50)">审批通过 </a-tag>
        <a-tag v-if="record.approveStatus === 2" color="rgb(255, 99, 71)">审批不通过</a-tag>
      </span>
      <div slot="action" slot-scope="text, record">
        <a-button
          size="small"
          type="primary"
          style="font-size: 12px; margin-right: 10px"
          @click="chakansclik(record.id)"
        >
          查看
        </a-button>
        <span v-if="record.executeUserId == climbId">
          <a-button
            v-if="record.constructionStatus == 1"
            size="small"
            style="font-size: 12px; background-color: rgb(246, 255, 237); color: green"
            @click="CloseProject(record)"
          >
            提交
          </a-button>
          <a-button
            v-if="record.constructionStatus == 0"
            size="small"
            style="font-size: 12px; background-color: rgb(246, 255, 237); color: green"
            @click="startck(record.id, 1, record)"
          >
            开始
          </a-button>
          <a-button
            v-if="record.constructionStatus == 2"
            size="small"
            style="font-size: 12px; background-color: rgb(246, 255, 237); color: green"
            disabled
          >
            完成
          </a-button>
        </span>
      </div>
    </a-table>

    <!-- 新增弹框 -->
    <a-modal
      :title="titles"
      style="top: 20px"
      :width="800"
      :destroyOnClose="true"
      :visible="addOrUpdateVisible"
      v-model="addOrUpdateVisible"
      @cancel="handleCancel"
    >
      <a-form-model
        class="tenant-form"
        :model="engineeringProjectConstruction"
        ref="engineeringProjectConstruction"
        :rules="rules"
      >
        <a-form-model-item label="项目编号" prop="establishmentNo" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input disabled v-model="engineeringProjectConstruction.establishmentNo" placeholder="系统自动按规则生成" />
        </a-form-model-item>
        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="审核状态" prop="approveStatus">
          <a-radio-group
            :disabled="disabled"
            v-model="engineeringProjectConstruction.approveStatus"
            @change="onChangejt"
          >
            <a-radio :value="1">审批通过</a-radio>
            <a-radio :value="2">审批不通过</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item
          label="审批意见"
          prop="approvalOpinion"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          v-if="engineeringProjectConstruction.approveStatus == 1"
        >
          <a-input v-model="engineeringProjectConstruction.approvalOpinion" />
        </a-form-model-item>
        <a-form-model-item
          label="执行人"
          prop="userId"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          v-if="engineeringProjectConstruction.approveStatus == 1"
        >
          <a-select placeholder="选择一个执行人" v-model="engineeringProjectConstruction.userId">
            <a-select-option v-for="item in userlist" :key="item.key.principalId" :value="item.key.principalId">
              {{ item.key.principal }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="附件" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <div class="fileDiv">
            <ul>
              <li class="fileLi" v-for="item in engineeringProjectConstruction.fileNames" :key="item.url">
                <span class="uploadDiv" @click="uploadFile(item)">
                  <a-icon type="file-done" style="cursor: pointer" />
                  {{ item.name }}
                </span>
              </li>
            </ul>
          </div>
        </a-form-model-item>
        <p>材料表</p>
        <a-table bordered :columns="columnsTw" :loading="dataListLoading" :data-source="datat">
          <span slot="approveStatus" slot-scope="text, record">
            <a-tag v-if="record.approveStatus === 0" color="rgb(255, 99, 71)">待审批</a-tag>
            <a-tag v-if="record.approveStatus === 1" color="rgb(50, 205, 50)">审批通过</a-tag>
            <a-tag v-if="record.approveStatus === 2" color="rgb(255, 99, 71)">审批不通过</a-tag>
          </span>
        </a-table>
      </a-form-model>
      <template #footer>
        <a-button @click="handleCancel">取消</a-button>
        <a-button type="primary" @click="handleces()" :disabled="disabled" v-show="titles == '施工完成'">完成</a-button>
      </template>
    </a-modal>
    <!-- 提交 -->
    <a-modal
      title="提交"
      style="top: 20px"
      :width="800"
      :visible="closure"
      :destroyOnClose="true"
      @cancel="CloseeCancel"
    >
      <a-form-model
        class="tenant-form"
        :model="engineeringProjectConstruction"
        ref="engineeringProjectConstruction"
        :rules="rules"
      >
        <a-form-model-item label="工程进度描述" prop="describe" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-model="engineeringProjectConstruction.describe" />
        </a-form-model-item>
        <div
          v-for="(item, index) in this.engineeringProjectConstruction.materials"
          :key="index"
          style="margin-bottom: 20px"
        >
          <a-row>
            <a-col :span="8">
              <a-form-model-item :labelCol="{ span: 8 }" :wrapperCol="{ span: 15 }" label="一级材料">
                <a-select placeholder="选择一级材料" default-value :labelInValue="true" @change="handleChan">
                  <a-select-option v-for="ite in zoneTreeData" :key="ite.id" :value="ite.id">
                    {{ ite.materialsName }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item :labelCol="{ span: 8 }" :wrapperCol="{ span: 15 }" label="二级材料">
                <a-select placeholder="选择二级材料" default-value @change="handleChans">
                  <a-select-option v-for="ite in zoneData" :key="ite.id" :value="ite.id">
                    {{ ite.materialsName }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item :labelCol="{ span: 8 }" :wrapperCol="{ span: 15 }" label="三级材料">
                <a-select
                  placeholder="选择三级材料"
                  default-value
                  v-model="engineeringProjectConstruction.materials[index].materialsName"
                >
                  <a-select-option v-for="ite in zoneDatat" :key="ite.id" :value="ite.id">
                    {{ ite.materialsName + ite.specificationName }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="8">
              <a-form-model-item :labelCol="{ span: 8 }" :wrapperCol="{ span: 15 }" label="数量">
                <a-input
                  v-model="engineeringProjectConstruction.materials[index].quantity"
                  oninput="value=value.replace(/[^\d^\.]+/g,'')"
                  onkeyup="value=value.replace(/[^\d^\.]+/g,'')"
                  style="width: 150px"
                />
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item :labelCol="{ span: 8 }" :wrapperCol="{ span: 15 }" label="单位">
                <a-select
                  placeholder="选择计量单位"
                  default-value
                  v-model="engineeringProjectConstruction.materials[index].unit"
                >
                  <a-select-option v-for="item in MateRial" :key="item.dictValue">{{ item.dictValue }}</a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-button
                v-if="item.flag"
                size="small"
                type="primary"
                style="font-size: 12px"
                @click="natureclick(naturclicks)"
              >
                添加
              </a-button>
              <a-button v-if="!item.flag" size="small" type="danger" style="font-size: 12px" @click="deleteArr(index)">
                删除
              </a-button>
            </a-col>
          </a-row>
        </div>
        <a-form-model-item :label-col="{ span: 7 }" :wrapper-col="{ span: 13 }">
          <a-button type="primary" style="margin-left: 85px" @click="WateroutageeventAdded()">停水事件新增</a-button>
        </a-form-model-item>
        <a-divider style="border-color: rgb(188 234 232)" dashed />
        <div v-for="(item, index) in this.Wateroutag" :key="index" style="margin-bottom: 20px; margin-left: 8px">
          <a-row>
            <a-col :span="12"
              ><span style="font-size: 16px; font-weight: bold">停水事件：</span><span>{{ item.eventName }}</span
              >(<span>{{ item.eventNo }}</span
              >)</a-col
            >
            <a-col :span="12">
              <a-button
                type="primary"
                style="margin-bottom: 10px; margin-right: 10px; height: 30px"
                @click="WateroutagCheck(item.id)"
                >查看</a-button
              >
              <a-button
                type="danger"
                style="margin-bottom: 10px; height: 30px"
                @click="WateroutagedeleteEvent(item.id, index)"
                >删除</a-button
              ></a-col
            >
          </a-row>
        </div>
        <a-form-model-item label="附件" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-upload-dragger
            name="file"
            :disabled="disabled"
            :multiple="true"
            :customRequest="customReques"
            :showUploadList="false"
          >
            <p class="ant-upload-drag-icon">
              <a-icon type="inbox" />
            </p>
            <p class="ant-upload-text">
              文件拖拽此处或
              <a>点击上传</a>
            </p>
          </a-upload-dragger>
          <div class="fileDiv">
            <ul>
              <li class="fileLi" v-for="item in engineeringProjectConstruction.fileNames" :key="item.url">
                <span class="uploadDiv" @click="uploadFile(item)">
                  <a-icon type="file-done" style="cursor: pointer" />
                  {{ item.name }}
                </span>
                <a-icon
                  type="delete"
                  style="float: right; cursor: pointer; margin-top: 13px"
                  @click="deleteFile(item.url)"
                />
              </li>
            </ul>
          </div>
        </a-form-model-item>
      </a-form-model>
      <p>进度列表</p>
      <a-table bordered :columns="columnsTwo" :loading="dataListLoading" :data-source="datas">
        <span slot="fileNames" slot-scope="text, record">
          <div class="fileDiv">
            <ul>
              <li class="fileLi" v-for="item in record.fileNames" :key="item.url">
                <span class="uploadDiv" @click="uploadFile(item)">
                  <a-icon type="file-done" style="cursor: pointer" />
                  {{ item.name }}
                </span>
                <!-- <a-icon type="delete" style="float: right; cursor: pointer" @click="deleteFile(item.url)" /> -->
              </li>
            </ul>
          </div>
        </span>
      </a-table>
      <p>材料表</p>
      <a-table bordered :columns="columnsTw" :loading="dataListLoading" :data-source="datat">
        <template slot="operation" slot-scope="text, record">
          <a @click="edit(record)">编辑</a>
        </template>
        <span slot="approveStatus" slot-scope="text, record">
          <a-tag v-if="record.approveStatus === 0" color="rgb(255, 99, 71)">待审批</a-tag>
          <a-tag v-if="record.approveStatus === 1" color="rgb(50, 205, 50)">审批通过</a-tag>
          <a-tag v-if="record.approveStatus === 2" color="rgb(255, 99, 71)">审批不通过</a-tag>
        </span>
      </a-table>
      <template #footer>
        <a-button @click="CloseeCancel">取消</a-button>
        <a-button type="primary" @click="affirmOk(0)">完成</a-button>
        <a-button type="primary" @click="affirmOk(1)">保存</a-button>
      </template>
    </a-modal>
    <!-- 查看详情 -->
    <a-modal
      title="查看详情"
      :visible="visibles"
      style="top: 20px"
      :width="800"
      :destroyOnClose="true"
      :confirm-loading="confirmLoading"
      @cancel="handleCancelhl"
    >
      <a-row>
        <a-col :span="12"
          ><p><span style="font-size: 16px"> 项目编码：</span>{{ Details.establishmentNo }}</p></a-col
        >
        <a-col :span="12"
          ><p><span style="font-size: 16px"> 项目名称：</span>{{ Details.establishmentName }}</p></a-col
        >
      </a-row>
      <a-row>
        <a-col :span="12"
          ><p><span style="font-size: 16px"> 联系方式：</span>{{ Details.phone }}</p></a-col
        >
        <a-col :span="12"
          ><p><span style="font-size: 16px"> 地址：</span>{{ Details.address }}</p></a-col
        >
      </a-row>
      <a-row>
        <a-col :span="12"
          ><p><span style="font-size: 16px"> 备注：</span>{{ Details.remark }}</p></a-col
        >
        <a-col :span="12"
          ><p><span style="font-size: 16px"> 执行人：</span>{{ Details.executeUserName }}</p></a-col
        >
      </a-row>
      <a-row>
        <a-col :span="12"
          ><p>
            <span style="font-size: 16px"> 施工状态：</span>
            <span>
              <a-tag v-if="Details.constructionStatus === 0" color="rgb(255, 99, 71)">未开始</a-tag>
              <a-tag v-if="Details.constructionStatus === 1" color="#f98303">施工进行中</a-tag>
              <a-tag v-if="Details.constructionStatus === 2" color="rgb(50, 205, 50)">施工已完成</a-tag>
            </span>
          </p></a-col
        >
        <a-col :span="12"
          ><p>
            <span style="font-size: 16px"> 审核状态：</span>
            <span>
              <a-tag v-if="Details.approveStatus === 0" color="rgb(255, 99, 71)">待审批</a-tag>
              <a-tag v-if="Details.approveStatus === 1" color="rgb(50, 205, 50)">审批通过 </a-tag>
              <a-tag v-if="Details.approveStatus === 2" color="rgb(255, 99, 71)">审批不通过</a-tag>
            </span>
          </p></a-col
        >
      </a-row>
      <a-row>
        <a-col :span="12"
          ><p><span style="font-size: 16px"> 计划开始时间：</span>{{ Details.startTime }}</p></a-col
        >
        <a-col :span="12"
          ><p><span style="font-size: 16px"> 计划完成时间：</span>{{ Details.endTime }}</p></a-col
        >
      </a-row>
      <a-row>
        <a-col :span="12">
          <span style="font-size: 16px">
            是否需要停水事件：<span v-if="this.Eventslength == 0">否</span>
            <span v-else>是</span>
          </span>
        </a-col>
        <a-col :span="12"
          ><p>
            <span style="font-size: 16px"> 停水事件详情：</span>
            <span v-for="(item, index) in this.Details.gisWaterEvents" :key="index">
              <p>
                <span>{{ item.eventName }}</span
                >(<span>{{ item.eventNo }}</span
                >)
                <a-button
                  type="primary"
                  style="margin-bottom: 10px; margin-right: 10px; height: 30px"
                  @click="DetailsCheck(item)"
                  >查看</a-button
                >
              </p>
            </span>
          </p></a-col
        >
      </a-row>
      <a-form-model class="log-form" :model="Details" :label-col="{ span: 2 }" :wrapper-col="{ span: 22 }">
        <a-form-model-item label="附件上传" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <div class="fileDiv">
            <ul>
              <li class="fileLi" v-for="item in Details.fileNames" :key="item.url">
                <span class="uploadDiv" @click="uploadFile(item)">
                  <a-icon type="file-done" style="cursor: pointer" />
                  {{ item.name }}
                </span>
                <!-- <a-icon type="delete" style="float: right; cursor: pointer" @click="deleteFile(item.url)" /> -->
              </li>
            </ul>
          </div>
        </a-form-model-item>
      </a-form-model>
      <p>进度列表</p>
      <a-table bordered :columns="columnsTwo" :loading="dataListLoading" :data-source="datas">
        <span slot="fileNames" slot-scope="text, record">
          <div class="fileDiv">
            <ul>
              <li class="fileLi" v-for="item in record.fileNames" :key="item.url">
                <span class="uploadDiv" @click="uploadFile(item)">
                  <a-icon type="file-done" style="cursor: pointer" />
                  {{ item.name }}
                </span>
                <!-- <a-icon type="delete" style="float: right; cursor: pointer" @click="deleteFile(item.url)" /> -->
              </li>
            </ul>
          </div>
        </span>
      </a-table>
      <template #footer>
        <a-button @click="handleCancelhl">取消</a-button>
      </template>
    </a-modal>
    <a-modal
      title="修改"
      :visible="visiblp"
      style="top: 20px"
      :width="500"
      :destroyOnClose="true"
      :confirm-loading="confirmLoading"
      @cancel="handleC"
      @ok="save"
    >
      <a-form-model class="tenant-form" :model="waterMaterials" ref="waterMaterials" :rules="rulest">
        <a-form-model-item :labelCol="{ span: 8 }" :wrapperCol="{ span: 15 }" label="数量" prop="quantity">
          <a-input
            v-model="waterMaterials.quantity"
            oninput="value=value.replace(/[^\d^\.]+/g,'')"
            onkeyup="value=value.replace(/[^\d^\.]+/g,'')"
            style="width: 150px"
          />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <WateroutageeventAdded ref="WateroutageeventAdded" v-on:childByValue="childByValue"></WateroutageeventAdded>
    <WateroDetails ref="WateroDetails" />
  </a-card>
</template>

<script>
import mixinViewModule from '@/mixin/common'
import WateroutageeventAdded from './WateroutageeventAdded/WateroutageeventAdded.vue'
import WateroDetails from './WateroutageeventAdded/WateroDetails.vue'

export default {
  components: {
    WateroutageeventAdded,
    WateroDetails,
  },
  name: 'PointCheck',
  mixins: [mixinViewModule],
  data() {
    return {
      queryUrl: '/pipe-network/engineering_project_constructions/page',
      queryOneUrl: '/pipe-network/engineering_project_constructions',
      needQuery: false,
      // addOrUpdateUrl: '/pipe-network/meter_reading_staffs', // 新增或更新数据url
      deleteUrl: '/pipe-network/engineering_project_constructions', // 删除数据url
      uploadUrl: 'manager/file/resources/upload', // 上传文件URL
      queryZoneDateUrl: '/pipe-network/water_materialss',
      recycleBinVisible: false,
      disabled: false,
      show: false,
      addOrUpdateVisible: false,
      visibles: false,
      confirmLoading: false,
      Eventslength: 0,
      visiblp: false,
      Details: {},
      zoneData: [],
      zoneDatas: [],
      zoneDatat: [],
      MateRial: [],
      MateRial: [],
      zoneTreeData: [],
      selectedRowKeys: [],
      disabled: false,
      list: [],
      query: {
        establishmentNo: '',
        establishmentName: '',
        startTime: '',
        endTime: '',
        constructionStatus: '',
        time: '',
      },
      titles: '',
      userlist: [],
      naturclicks: 1,
      natureList: [
        {
          materialsName: '',
          materialType: '',
          quantity: '',
          unit: '',
          materialsNo: '',
          waterType: 0,
          flag: true,
        },
      ],
      engineeringProjectConstruction: {
        establishmentNo: '',
        constructionStatus: '',
        approveStatus: 0,
        pipeline: '',
        mileage: 0,
        id: 0,
        fileNames: [],
        gisEventIds: [],
        materials: [
          {
            materialsName: '',
            materialType: '',
            quantity: '',
            unit: '',
            materialsNo: '',
            waterType: 0,
            flag: true,
          },
        ],
        describe: '',
        closeOrOpen: 0,
        executeUserName: '',
        userId: '',
        approvalOpinion: '',
      },
      waterMaterials: {
        id: '',
        quantity: '',
        materialsNo: '',
        materialsName: '',
        materialType: '',
        unit: '',
        createTime: '',
        approveStatus: '',
        establishmentNo: '',
      },
      rulest: {
        quantity: [{ required: true, message: '请材料数量"', trigger: 'change' }],
      },
      rules: {
        userId: [{ required: true, message: '请选择执行人"', trigger: 'change' }],
        pipeline: [{ required: true, message: '请输入管道名称', trigger: 'change' }],
        mileage: [
          { required: true, message: '请输入管道公里数', trigger: 'change' },
          {
            pattern: /^\d+$|^\d*\.\d+$/g,
            message: '请正确的公里数',
            trigger: 'change',
          },
        ],
        describe: [{ required: true, message: '请输入进度描述', trigger: 'change' }],
        approveStatus: [{ required: true, message: '请选择审批状态', trigger: 'change' }],
        approvalOpinion: [{ required: true, message: '请输入审批意见', trigger: 'change' }],
      },
      isShow: false,
      isShowl: false,
      visible: false,
      closure: false,
      disables: false,
      uploadl: false,
      climbId: null,
      editingKey: '',
      blishmentNo: '',
      Wateroutag: [],
      waterMaterialLinkageQuery: {
        id: '',
        type: 1,
      },
      columns: [
        {
          title: '项目编号',
          dataIndex: 'establishmentNo',
        },
        {
          title: '项目名称',
          dataIndex: 'establishmentName',
        },
        {
          title: '计划开始时间',
          dataIndex: 'startTime',
        },
        {
          title: '计划结束时间',
          dataIndex: 'endTime',
        },
        {
          title: '实际结束时间',
          dataIndex: 'realityEndTime',
        },
        {
          title: '项目负责人',
          dataIndex: 'executeUserName',
        },
        {
          title: '施工状态',
          dataIndex: 'constructionStatus',
          scopedSlots: { customRender: 'constructionStatus' },
        },
        {
          title: '审批状态',
          dataIndex: 'approveStatus',
          scopedSlots: { customRender: 'approveStatus' },
        },
        {
          title: '备注',
          dataIndex: 'remark',
        },
        {
          title: '审批意见',
          dataIndex: 'approvalOpinion',
        },
        {
          title: '操作',
          align: 'center',
          key: 'operation',
          fixed: 'right',
          width: 150,
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
        },
      ],
      columnsTwo: [
        {
          title: '序号',
          // width: '70px',
          dataIndex: '',
          key: 'rowIndex',
          customRender: function (t, r, index) {
            return parseInt(index) + 1
          },
        },
        {
          title: '工程进度描述',
          dataIndex: 'describe',
        },
        {
          title: '附件',
          width: '300px',
          dataIndex: 'fileNames',
          scopedSlots: { customRender: 'fileNames' },
        },
        {
          title: '上传日期',
          dataIndex: 'createTime',
        },
      ],
      columnsTw: [
        {
          title: '序号',
          // width: '70px',
          dataIndex: '',
          key: 'rowIndex',
          customRender: function (t, r, index) {
            return parseInt(index) + 1
          },
        },
        {
          title: '材料编码',
          dataIndex: 'materialsNo',
        },
        {
          title: '材料名称',
          dataIndex: 'materialsName',
          scopedSlots: { customRender: '' },
        },
        {
          title: '材料规格',
          dataIndex: 'materialType',
        },
        {
          title: '数量',
          dataIndex: 'quantity',
          scopedSlots: { customRender: 'quantity' },
        },
        {
          title: '单位',
          dataIndex: 'unit',
        },
        {
          title: '审批状态',
          dataIndex: 'approveStatus',
          scopedSlots: { customRender: 'approveStatus' },
        },
        {
          title: '时间',
          dataIndex: 'updateTime',
        },
        {
          title: '操作',
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
        },
      ],
      datas: [],
      datat: [],
      digli: [],
      currentIds: [],
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showTotal: (total) => `共 ${total} 条记录`,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100'],
      },
      createTaskFrom: {
        name: '',
      },
      addOrUpdateForm: this.$form.createForm(this, { name: 'addOrUpdate' }),
      labelCol: { span: 4 },
      wrapperCol: { span: 18 },
    }
  },
  created() {
    this.queryList()
    this.Responsibleinterface()
    this.resetList()
    this.currentUser()
    this.getZoneData()
    this.getTaskList()
  },
  methods: {
    childByValue(childValue) {
      console.log(childValue,'数据！');
      if (childValue.id !== undefined) {
        let obj = {
          eventName: childValue.eventName,
          eventNo: childValue.eventNo,
          id: childValue.id,
        }
        this.Wateroutag.push(obj)
        let ids = childValue.id
        this.engineeringProjectConstruction.gisEventIds.push(ids)
        this.currentIds.push(ids)
        console.log(this.Wateroutag, '数据')
      }
    },
    WateroutageeventAdded() {
      this.$refs.WateroutageeventAdded.ReassignHandle()
    },
    WateroutagCheck(id) {
      this.$refs.WateroutageeventAdded.CheckUpdateHandle(id)
    },
    DetailsCheck(item) {
      this.$refs.WateroDetails.DetailsHandle(item)
    },
    WateroutagedeleteEvent(id, index) {
      const _this = this
      let currentId = id
      let indexs = index
      console.log(id)
      this.$confirm({
        title: `删除提醒`,
        content: `您确认要删除此条数据吗?`,
        okText: '确认',
        okType: 'danger',
        cancelText: '取消',
        onOk() {
          _this.$http
            .delete(`/pipe-network/gis_water_events/${currentId}`)
            .then((res) => {
              if (res.code === 0) {
                _this.Wateroutag.splice(indexs, 1)
                console.log(_this.Wateroutag, '数据！')
                _this.$message.success(`已删除此条数据`)
                _this.selectedRows = []
                _this.resetList()
                _this.queryList()
              }
            })
            .catch(() => {})
        },
        onCancel() {
          _this.selectedRows = []
          _this.$message.info('已取消删除')
        },
      })
    },
    edit(record) {
      this.visiblp = true
      this.waterMaterials = {
        id: record.id,
        quantity: record.quantity,
        materialsNo: record.materialsNo,
        materialsName: record.materialsName,
        materialType: record.materialType,
        unit: record.unit,
        createTime: record.createTime,
        approveStatus: record.approveStatus,
        establishmentNo: record.establishmentNo,
        gisEventIds: record.gisEventIds,
      }
    },
    handleC() {
      this.$refs.waterMaterials.resetFields()
      this.visiblp = false
    },
    save() {
      this.$refs.waterMaterials.validate((valid) => {
        if (valid) {
          this.$http.put('/pipe-network/engineering_project_materialss', { ...this.waterMaterials }).then((res) => {
            if (res.code == 0) {
              this.$message.success(res.message)
              this.visiblp = false
              this.materialmethod(this.blishmentNo)
              this.$refs.waterMaterials.resetFields()
            } else {
              this.$message.success('操作失败！')
            }
          })
        }
      })
    },
    //字典
    getTaskList() {
      const params = {
        dictCode: 'MATERIAL-UNIT-OF-MEASURE',
      }
      this.$http.get('/manager/dicts/children', { params }).then(({ data }) => {
        this.MateRial = data
      })
    },
    materialmethod(i) {
      this.digli = i
      let params = {
        establishmentNo: i,
      }
      this.$http.get('/pipe-network/engineering_project_materialss/page', { params }).then((res) => {
        this.datat = res.data.list
      })
    },
    getZoneData(i) {
      let params = {
        id: this.waterMaterialLinkageQuery.id,
        type: this.waterMaterialLinkageQuery.type,
      }
      this.$http.get(this.queryZoneDateUrl, { params }).then(({ data }) => {
        this.zoneTreeData = data
      })
    },
    handleChan(value) {
      console.log(value)
      this.zoneData = []
      this.erid = value.key
      this.waterMaterialLinkageQuery = {
        id: this.erid,
        type: 3,
      }
      let params = {
        id: this.waterMaterialLinkageQuery.id,
        type: this.waterMaterialLinkageQuery.type,
      }
      this.$http.get(this.queryZoneDateUrl, { params }).then(({ data }) => {
        this.zoneData = data
      })
    },
    handleChans(value) {
      this.waterMaterialLinkageQuery = {
        id: this.erid,
        type: 2,
      }
      let params = {
        id: this.waterMaterialLinkageQuery.id,
        type: this.waterMaterialLinkageQuery.type,
      }
      this.$http.get(this.queryZoneDateUrl, { params }).then(({ data }) => {
        this.zoneDatat = data
      })
    },
    currentUser() {
      this.climbId = this.$store.getters.userInfo.id
      console.log(this.climbId)
    },
    token() {
      return this.$store.getters.token
    },
    //开始
    startck(id, i, recordt) {
      this.engineeringProjectConstruction.id = id
      this.engineeringProjectConstruction.constructionStatus = i
      this.engineeringProjectConstruction = {
        id: id,
        executeUserName: recordt.executeUserName,
        establishmentNo: recordt.establishmentNo,
        fileNames: recordt.fileNames,
        establishmentName: recordt.establishmentName,
        phone: recordt.phone,
        describe:recordt.describe,
        constructionStatus: i,
        materials: [
          {
            materialsName: '',
            materialType: '',
            quantity: '',
            unit: '',
            materialsNo: '',
            waterType: 0,
            flag: true,
          },
        ],
      }
      this.$http
        .put('/pipe-network/engineering_project_constructions', {
          id: this.engineeringProjectConstruction.id,
          ...this.engineeringProjectConstruction,
        })
        .then((res) => {
          console.log(res.data)
          if (res.message == '操作成功') {
            this.$message.success(res.message)
            this.queryList()
          } else {
            this.$message.success('操作失败')
          }
        })
    },
    deleteArr(index) {
      this.engineeringProjectConstruction.materials.splice(index, 1)
    },
    natureclick(i) {
      console.log(i)
      let obj = {
        waterType: 0,
        flag: false,
        materialsName: '',
        materialType: '',
        quantity: '',
        unit: '',
        materialsNo: '',
      }
      if (this.engineeringProjectConstruction.materials.length <= 9) {
        this.engineeringProjectConstruction.materials.push(obj)
      }
    },
    //负责人下拉框
    Responsibleinterface() {
      this.$http.get('/pipe-network/engineering_project_establishments/principals').then(({ data }) => {
        let list = []
        data.map((item) => {
          console.log(item)
          list.push({
            key: item,
          })
        })
        this.userlist = list
      })
    },
    componenthsd(id, i) {
      // 回选方法
      this.engineeringProjectConstruction.id = id
      this.$http(`/pipe-network/engineering_project_constructions/${this.engineeringProjectConstruction.id}`)
        .then((res) => {
          this.Projectconstructionschedule(res.data.establishmentNo)
          this.engineeringProjectConstruction.executeUserName = res.data.executeUserName
          this.engineeringProjectConstruction.establishmentNo = res.data.establishmentNo
          this.engineeringProjectConstruction.constructionStatus = res.data.constructionStatus
          this.engineeringProjectConstruction.approveStatus = res.data.approveStatus
          this.digli = res.data.establishmentNo
          // this.engineeringProjectConstruction.gisEventIds =res.data.gisEventIds
          this.materialmethod(this.digli)
        })
        .catch(() => {})
    },
    chakansclik(id) {
      this.$http(`/pipe-network/engineering_project_constructions/${id}`).then((res) => {
        this.Details = res.data
        this.Eventslength = res.data.gisWaterEvents.length
        this.Projectconstructionschedule(res.data.establishmentNo)
      })
      this.visibles = true
    },
    handleCancelhl() {
      this.visibles = false
    },
    // 项目施工进度表
    Projectconstructionschedule(i) {
      let establishmentNo = i
      this.$http
        .post('/pipe-network/engineering_project_constructions/schedule-details', {
          establishmentNo: establishmentNo,
        })
        .then((res) => {
          this.datas = res.data.schedules
        })
    },
    chakan() {
      this.titles = '施工完成'
      this.uploadl = false
      if (this.selectedRows.length == 1) {
        this.currentId = this.selectedRows[0]
        this.componenthsd(this.currentId, this.titles)
        this.addOrUpdateVisible = true
      } else if (this.selectedRows.length == 0) {
        return this.$message.warn('请选择一条事件')
      } else {
        return this.$message.warn('只能选择一条事件')
      }
      this.visible = true
    },
    //完成
    handleces() {
      this.$refs.engineeringProjectConstruction.validate((valid) => {
        if (valid) {
          this.$http
            .post('/pipe-network/engineering_project_constructions/completion', {
              id: this.engineeringProjectConstruction.id,
              ...this.engineeringProjectConstruction,
            })
            .then((res) => {
              console.log(res.data, '返回')
              if (res.code == 0) {
                this.addOrUpdateVisible = false
                this.queryList()
                this.$message.success('修改成功')
              } else {
                return this.$message.error('修改失败！')
              }
            })
          this.$refs.engineeringProjectConstruction.resetFields()
        } else {
          return false
        }
      })
    },
    //编辑
    handlece() {
      this.$refs.engineeringProjectConstruction.validate((valid) => {
        if (valid) {
          this.$http
            .post('/pipe-network/engineering_project_constructions/saveSchedule', {
              id: this.engineeringProjectConstruction.id,
              ...this.engineeringProjectConstruction,
            })
            .then((res) => {
              if (res.code == 0) {
                this.addOrUpdateVisible = false
                this.queryList()
                this.$message.success('修改成功')
              } else {
                return this.$message.error('修改失败！')
              }
            })
          this.$refs.engineeringProjectConstruction.resetFields()
        } else {
          return false
        }
      })
    },
    //提交
    CloseProject(record) {
      this.engineeringProjectConstruction.id = record.id
      this.componenthsd(record.id)
      this.materialmethod(record.establishmentNo)
      this.blishmentNo = record.establishmentNo
      this.engineeringProjectConstruction.establishmentNo = record.establishmentNo
      this.closure = true
      record.gisWaterEvents.map((item) => {
        this.Wateroutag.push({
          eventName: item.eventName,
          eventNo: item.eventNo,
          id: item.id,
        })
      })
      this.Wateroutag.map((item) => {
        this.engineeringProjectConstruction.gisEventIds.push(item.id)
      })
    },
    //确认提交
    affirmOk(i) {
      if (i == 0) {
        this.engineeringProjectConstruction.constructionStatus = 2
      } else {
        this.engineeringProjectConstruction.constructionStatus = 1
      }
      this.$refs.engineeringProjectConstruction.validate((valid) => {
        if (valid) {
          this.$http
            .post('/pipe-network/engineering_project_constructions/saveSchedule', {
              id: this.engineeringProjectConstruction.id,
              ...this.engineeringProjectConstruction,
            })
            .then((res) => {
              this.$message.success(res.message)
              this.$refs.engineeringProjectConstruction.resetFields()
              this.engineeringProjectConstruction.fileNames = []
              this.Wateroutag = []
              this.engineeringProjectConstruction.materials = [
                {
                  materialsName: '',
                  materialType: '',
                  quantity: '',
                  unit: '',
                  materialsNo: '',
                  waterType: 0,
                  flag: true,
                },
              ]
              this.closure = false
              this.queryList()
            })
        }
      })
    },
    //取消
    CloseeCancel() {
      this.$refs.engineeringProjectConstruction.resetFields()
      this.engineeringProjectConstruction.fileNames = []
      this.Wateroutag = []
      this.engineeringProjectConstruction.materials = [
        {
          materialsName: '',
          materialType: '',
          quantity: '',
          unit: '',
          materialsNo: '',
          waterType: 0,
          flag: true,
        },
      ]
      this.closure = false
      // const _this = this
      // this.$http
      //   .delete('/pipe-network/gis_water_events', { data: _this.currentIds })
      //   .then((res) => {
      //     if (res.code === 0) {
      //       // _this.Wateroutag.splice(indexs, 1)
      //       _this.selectedRows = []
      //       _this.resetList()
      //       _this.queryList()
      //       _this.currentIds = []
      //       this.closure = false
      //     }
      //   })
      //   .catch(() => {})
    },
    handleCancel() {
      this.addOrUpdateVisible = false
      this.visible = false
      this.$refs.engineeringProjectConstruction.resetFields()
    },
    onChange(date, dateString) {
      console.log(date, dateString)
    },
    onChangetime(value, dateString) {},
    onOk(value) {},
    //文件上传
    customReques(data) {
      // 上传提交
      const formData = new FormData()
      formData.append('file', data.file)
      this.saveFile(formData)
    },
    saveFile(formData) {
      this.importLoading = true
      this.axios({
        method: 'post',
        url: this.uploadUrl,
        headers: {},
        params: {},
        data: formData,
      })
        .then((response) => {
          if (response.code === 0) {
            let obj = {
              url: response.data.url,
              name: response.data.fileName,
            }
            if (this.engineeringProjectConstruction.fileNames.length == 5) {
              this.$message.error('最多上传5个文件')
            } else {
              this.engineeringProjectConstruction.fileNames.push(obj)
            }
          }
        })
        .catch(function (error) {})
        .finally(() => {
          this.importLoading = false
        })
    },
    uploadFile(item) {
      const link = document.createElement('a') // 创建a标签
      link.download = item.name // a标签添加属性
      link.style.display = 'none'
      link.href = item.url
      document.body.appendChild(link)
      link.click() // 执行下载
      document.body.removeChild(link) // 释放标签
    },
    deleteFile(url) {
      let index = this.engineeringProjectConstruction.fileNames.findIndex((item) => {
        return item.url == url
      })
      this.engineeringProjectConstruction.fileNames.splice(index, 1)
    },
    onChangejt(value) {},
  },
}
</script>

<style lang="less" scoped>
/deep/.table-striped {
  background-color: #fafafa;
}
.log-form {
  /deep/ .permission-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}
.fileLi {
  // display: flex;
  // justify-content: space-between;
  // align-items: center;
  margin: 8px 0;
}

.a-card {
  width: 100%;
  height: 100%;
}
/deep/.ant-table-thead > tr > th > {
  text-align: center;
}

/deep/.ant-table-tbody > tr > td {
  text-align: center;
}
</style>
